import React from 'react';

import Card from './card/Card';

import styles from './Cards.module.scss';


const Cards = (props) => {
  const cardClasses = [styles.CardsContainer];

  if (props.className) cardClasses.push(props.className);

  return (
    <div className={cardClasses.join(' ')}>
      {props.cards.map(card => {
        return (
          <Card description={card.v} key={card.id} />
        );
      })}
    </div>
  );
}

Cards.defaultProps = {
  cards: [],
};

export default Cards;
